import { Pipe, PipeTransform } from '@angular/core';
import { EDirectDepositStatusType } from '@app/views/pages/deposit/history/transactions-list/modules/direct-deposit-history/types/direct-deposit-status.type';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
	name: 'requestStatusTextDirectDeposit',
	standalone: true
})
export class RequestStatusTextDirectDepositPipe implements PipeTransform {

	constructor(private translateService: TranslateService) {
	}

	RequestStatus = EDirectDepositStatusType;
	translatedText: string;

	transform(value: EDirectDepositStatusType): any {
		this.getTranslate(
			this.RequestStatus.getTitle(value)
		);

		return this.translatedText;
	}

	async getTranslate(text: string) {
		text = 'ENUM.REQUEST_STATUS_DIRECT_DEPOSIT.' + text;
		const m = await this.translateService.get(text).subscribe(
			res => {
				this.translatedText = res;
			}
		);
	}
}

